var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2GuestsBedroomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 41h3v11.36a10.22 10.22 0 008.49 10.21A9.999 9.999 0 0064 52.68V41h3v-4H41v4zm7 0h12v11.49a6.11 6.11 0 01-4.66 6A6 6 0 0148 52.68V41zm19-13v6H41v-6-.55c.3-7.36 6.36-14.17 13.53-13.86 7 .3 12.47 7.3 12.47 14.41zM9 41h3v11.36a10.22 10.22 0 008.49 10.21A9.999 9.999 0 0032 52.68V41h3v-4H9v4zm7 0h12v11.49a6.11 6.11 0 01-4.66 6A6 6 0 0116 52.68V41zm15.39-22.76A15.45 15.45 0 0135 28v6H9v-6.55c0-7.34 6.36-14.17 13.53-13.86a12.321 12.321 0 018.86 4.65z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Guests_bedroom_bis.d01c0d30.svg";
export { SvgE2GuestsBedroomBis as ReactComponent };